/* eslint-disable camelcase */
/* eslint-disable ordered-imports/ordered-imports */
import DeliveryIcon from "@NA/Icons/DeliveryIcon";
import StoreIcon from "@NA/Icons/StoreIcon";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import { ProductAddToListLinkStyles } from "@insite/content-library/Components/ProductAddToListLink";
import { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import { ProductQuantityBreakPricingStyles } from "@insite/content-library/Components/ProductQuantityBreakPricing";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Link from "@insite/mobius/Link/Link";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldProps } from "@insite/mobius/TextField";
import { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { Hidden, LoadingSpinner, Modal, Typography } from "@insite/mobius/index";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import { connect, ResolveThunks, useSelector } from "react-redux";
import { css, keyframes } from "styled-components";
import getColor from "@insite/mobius/utilities/getColor";
import CrossIcon from "@NA/Icons/CrossIcon";
import ADILocationFinder from "@NA/Components/ADILocationFinder";
import { ModalPresentationProps } from "@insite/mobius/Modal";
import customLoadInventory from "@NA/Handlers/GetInventory";
import { isPriceAvailable } from "@NA/Utils/Utility";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import siteMessage from "@insite/client-framework/SiteMessage";
import ADIColors from "@NA/Utils/ADIColors";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { pushDealerAuthDataToDataLayer } from "@NA/Overrides/Common/Utilities/CustomTracking";
import { HasProductContext, withProductContext } from "@NA/Components/Coveo/Contexts/CoveoProductContext";
import CoveoProductPrice from "@NA/Components/Coveo/ProductCardView/CoveoProductPrice";
import CoveoProductQuantityOrdered from "@NA/Components/Coveo/ProductCardView/CoveoProductQuantityOrdered";
import CoveoProductAddToCartButton from "@NA/Components/Coveo/ProductCardView/CoveoProductAddToCartButton";
import FilterDown from "@NA/Icons/FilterDown";
import CoveoAddToList from "@NA/Components/Coveo/CoveoAddToList";
import ADILBShippedByVendor from "@NA/Components/ADILBShippedByVendor";
import ADILBStorePickup from "@NA/Components/ADILBStorePickup";
import { getMaxProductHeight } from "@NA/Utils/Utility";
import CoveoDealerCertModal from "../CoveoDealerCertModal";

interface OwnProps {
    showPrice: boolean;
    showAddToList: boolean;
    loadingLivePrice?: boolean;
}

const mapStateToProps = (state: CustomApplicationState) => {
    const adiUserRoles = state.ADIGlobalData.ADIUserRoleStore;
    const session = getSession(state);
    let customerNumber = "";
    const billToId = session?.billToId;
    if (billToId) {
        customerNumber = state.data.billTos.byId[billToId]?.customerNumber;
    }
    return {
        productSettings: getSettingsCollection(state).productSettings,
        view: state.pages.productList.view,
        cartState: getCurrentCartState(state).value,
        cartStateLoading: getCurrentCartState(state).isLoading,
        session,
        showADIAddToList: (adiUserRoles.fullAccess && adiUserRoles.accounting) || adiUserRoles.fullAccess,
        customerNumber,
        currencySymbol: state.context.session.currency?.currencySymbol ?? "",
        coveoCommerce: state.ADIGlobalData.coveoCommerce,
    };
};

const mapDispatchToProps = {
    customLoadInventory,
};

type Props = ReturnType<typeof mapStateToProps> &
    HasProductContext &
    ResolveThunks<typeof mapDispatchToProps> &
    OwnProps;

export interface ProductListActionsStyles {
    wrapper?: InjectableCss;
    addToCartWrapper?: InjectableCss;
    addToCartButton?: ButtonPresentationProps;
    quantityOrdered?: TextFieldProps;
    unitOfMeasureSelect?: SelectPresentationProps;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    price?: ProductPriceStyles;
    addToListLink?: ProductAddToListLinkStyles;
    addToListWrapper?: InjectableCss;
    availability?: InjectableCss;
    contentWrapper?: InjectableCss;
    listDisplay?: InjectableCss;
    listDisplayWrapper?: InjectableCss;
    free?: TypographyProps;
    notFree?: TypographyProps;
    listAddToCartWrapper?: InjectableCss;
    addToListText?: TypographyProps;
    availabilityByWarehouseModal?: ModalPresentationProps;
    dealerCertificationModal?: ModalPresentationProps;
    priceAvailability?: InjectableCss;
    dealerCertificationWrapper?: InjectableCss;
    dealerCertificationTitle?: InjectableCss;
    getCertifiedText?: InjectableCss;
    variantContainer?: InjectableCss;
    listVariantWrap?: InjectableCss;
    gridVariantWrap?: InjectableCss;
    realTimeText?: InjectableCss;
    siteMessageGeocodeErrorText?: InjectableCss;
    buttonStyle?: InjectableCss;
    VerificationText?: TypographyPresentationProps;
}

const noAnimation = keyframes`
    from { opacity: 1; }
    to { opacity: 1; }
`;

export const actionsStyles: ProductListActionsStyles = {
    VerificationText: {
        css: css`
                           
                                text-transform: none !important;
                                font-size: 14px !important;
                                font-weight: bold;
                                color: ${ADIColors.blue5} !important;                              
                            }
                        `,
    },
    wrapper: {
        css: css`
            display: flex;
            width: 100%;
            flex-direction: column;
        `,
    },
    dealerCertificationWrapper: {
        css: css`
            border-top: solid 1px ${ADIColors.gray7};
            text-align: center;
            padding: 6.5px 4px !important;
            height: 55px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            &.productListView {
                border-top: none;
                justify-content: flex-start;
                align-items: flex-start;
                > div:first-child {
                    font-weight: 600;
                }
                > button > span {
                    padding-top: 10px;
                }
            }
        `,
    },
    dealerCertificationTitle: {
        css: css`
            font-weight: bold;
            color: ${ADIColors.darkBlack3};
            text-align: center;
            font-size: 16px;
            line-height: 1;
            @media only screen and (min-width: 1080px) and (max-width: 1440px) {
                font-size: 12px;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                //overflow: hidden;
                word-break: break-word;
            }
            @media only screen and (min-width: 768px) and (max-width: 1079px) {
                white-space: nowrap;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: 12px;
                        `,
                        css`
                            font-size: 13px;
                        `,
                        css`
                            font-size: 16px;
                        `,
                        css`
                            font-size: 12px;
                        `,
                        css`
                            font-size: 16px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    getCertifiedText: {
        css: css`
            > span {
                text-transform: none !important;
                font-size: 14px !important;
                font-weight: bold;
            }
        `,
    },
    unitOfMeasureSelect: {
        cssOverrides: {
            formField: css`
                margin-top: 20px;
            `,
        },
    },
    quantityBreakPricing: {
        viewLink: {
            css: css`
                margin: 8px 0;
            `,
        },
    },
    addToCartWrapper: {
        css: css`
            position: relative;
            bottom: 0;
            width: 100%;
        `,
    },
    addToCartButton: {
        css: css`
            width: 100%;
            border: 0;
            border-top: 1px solid ${getColor("text.disabled")};
            text-align: center;
            padding: 20px 0;
            cursor: pointer;
            transition: 0.2s ease;
            margin-top: auto;
            border-radius: 0;
            background: ${ADIColors.white};
            height: 55px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom-right-radius: 5px;
            border-bottom-left-radius: 5px;
            :disabled {
                background: ${ADIColors.white} !important;
                cursor: not-allowed;
                border-top: 1px solid ${getColor("text.disabled")} !important;
            }
            span {
                color: ${getColor("primary")};
            }
            :hover {
                background-color: ${getColor("primary")};
                span {
                    color: ${ADIColors.white};
                }
            }

            img {
                width: 40px;
            }
        `,
    },
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                margin-right: 10px;
                width: 4.1rem;
                min-width: 4.1rem;
            `,
        },
    },
    addToListWrapper: {
        css: css`
            user-select: none;
            position: relative;
            display: inline-block;
        `,
    },
    availability: {
        css: css`
            font-weight: bold;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            span {
                font-weight: bold;
                font-size: ${getProp("theme.typography.headerSecondary.size")};
                :hover {
                    text-decoration: underline;
                }
            }
        `,
    },
    priceAvailability: {
        css: css`
            margin-top: 10px;
            font-weight: bold;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            span {
                font-weight: bold;
                font-size: ${getProp("theme.typography.headerSecondary.size")};
            }
        `,
    },
    availabilityByWarehouseModal: {
        sizeVariant: "medium",
        closeButtonIconProps: {
            src: CrossIcon,
            size: 20,
        },
        transition: {
            enabled: false,
            length: 0,
            overlayEntryKeyframes: noAnimation,
            overlayExitKeyframes: noAnimation,
            scrimEntryKeyframes: noAnimation,
            scrimExitKeyframes: noAnimation,
        },
        cssOverrides: {
            modalBody: css`
                max-width: 730px !important;
                border-radius: 4px;
                padding: 28px !important;
                max-height: fit-content !important;
                transition: none !important;
                animation: none !important;
            `,
            modalContainer: css`
                transition: none !important;
                animation: none !important;
            `,
            modalContent: css`
                padding: 0;
            `,
            modalTitle: css`
                border-bottom: 0;
                padding: 0 !important;
                margin-bottom: 20px;
                > h4 {
                    font-size: 32px;
                    font-weight: bold;
                    font-family: "Nunito Sans", sans-serif;
                    line-height: normal;
                    color: ${ADIColors.darkBlue1};
                }
                button {
                    border-radius: 0;
                    svg {
                        height: 20px;
                    }
                }
            `,
            headlineTypography: css`
                font-size: 20px;
                margin-bottom: 0;
            `,
        },
    },
    dealerCertificationModal: {
        sizeVariant: "medium",
        closeButtonIconProps: {
            src: CrossIcon,
            size: 20,
        },
        cssOverrides: {
            modalBody: css`
                max-width: 548px !important;
                border-radius: 4px;
                padding: 28px 55px 38px 28px !important;
            `,
            modalContent: css`
                padding: 0;
            `,
            modalTitle: css`
                border-bottom: 0;
                padding: 0 !important;
                margin-bottom: 20px;
                > h4 {
                    font-size: 32px;
                    font-weight: bold;
                    font-family: "Nunito Sans", sans-serif;
                    line-height: normal;
                    color: ${ADIColors.darkBlue1};
                }
                button {
                    border-radius: 0;
                    svg {
                        height: 20px;
                    }
                }
            `,
            headlineTypography: css`
                font-size: 20px;
                margin-bottom: 0;
            `,
        },
    },
    price: {
        price: {
            priceText: {
                css: css`
                    flex-direction: row;
                    flex-wrap: wrap;
                    display: flex;
                    color: ${getColor("text.main")};
                    font-size: 30px;
                    sup:first-child {
                        display: inline-block;
                        margin-top: -1px;
                        font-size: 18px;
                        font-weight: 900;
                        margin-left: 0;
                        margin-right: 2px;
                    }

                    span {
                        font-size: 30px;
                        font-weight: 900;
                        line-height: 30px;
                        margin-bottom: 0px;
                        display: block;
                    }
                    sup:last-child {
                        font-weight: 900;
                        font-size: 18px;
                        font-stretch: normal;
                        line-height: normal;
                        margin-left: 2px;
                        margin-top: -1px;
                    }
                `,
            },
        },
    },
    contentWrapper: {
        css: css`
            padding: 5px 20px 0px 20px;
        `,
    },
    listDisplay: {
        css: css`
            user-select: none;
            display: flex;
            align-items: flex-start;
            margin-top: 10px;
            font-weight: bold;
            svg {
                margin-right: 7px;
            }
            span {
                font-size: 12px;

                color: ${ADIColors.darkBlue1};
                display: block;
            }
        `,
    },
    listDisplayWrapper: {
        css: css`
            margin-bottom: 10px;
            min-height: auto;
        `,
    },
    free: {
        css: css`
            color: ${ADIColors.lightGreen1} !important;
        `,
    },
    notFree: {
        css: css`
            color: ${ADIColors.orange1} !important;
        `,
    },
    listAddToCartWrapper: {
        css: css`
            button {
                border: solid 1px ${getColor("primary")} !important;
                padding: 10px;
                border-radius: 4px;
                margin: 10px 0;
                height: 35px;
                :disabled {
                    border: solid 1px ${getColor("primary")} !important;
                }
            }
        `,
    },
    addToListText: {
        as: "span",
        css: css`
            color: ${ADIColors.darkBlue1};
            font-weight: 600;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            cursor: pointer;
            position: relative;
            svg {
                width: 13px;
                height: 7px;
                margin-left: 12px;
            }
        `,
    },
    variantContainer: {
        css: css`
            position: relative;
            padding: 5px 0px 10px 0;
            min-height: 39px;
            span {
                font-size: 12px;
                font-weight: bold;
                color: #002856;
                line-height: 1.67;
            }
        `,
    },
    gridVariantWrap: {
        css: css`
            padding: 0 20px;
        `,
    },
    listVariantWrap: {
        css: css`
            margin-top: -0.5rem;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css``,
                        css``,
                        css`
                            padding-top: 1rem;
                            margin-top: -1rem;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    realTimeText: {
        css: css`
            display: inline-block;
            text-align: left;
            min-width: 25px;
            font-weight: 900;

            &::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                animation: ellipsis steps(4, end) 900ms infinite 1s;
                content: "";
                width: 0;
            }

            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }
        `,
    },
    siteMessageGeocodeErrorText: {
        css: css`
            font-family: "Nunito Sans" !important;
            font-size: 14px;
            font-weight: normal;
            line-height: 1.71;
            color: #2d2926;
        `,
    },
    buttonStyle: {
        css: css`
            padding-top: 20px;
        `,
    },
};

const styles = actionsStyles;

const CoveoProductListActions: FC<Props> = ({
    coveoproductContext,
    productSettings,
    showPrice,
    cartState,
    cartStateLoading,
    view,
    customLoadInventory,
    session,
    customerNumber,
    showAddToList,
    showADIAddToList,
    coveoCommerce,
}) => {
    const pricingLoading = !coveoproductContext.coveoProductInfo.pricing;
    const pricingIsAvailable = isPriceAvailable(
        coveoproductContext.coveoProductInfo.pricing,
        coveoproductContext.coveoProductInfo.qtyOrdered,
    );

    const isPRRegion = typeof window !== "undefined" && window.location.hostname.endsWith(".pr");

    const loadingRealtimePrice = coveoCommerce.loadingRealTimePricing;

    const pricingError = !pricingIsAvailable && !pricingLoading;

    const coveoProduct = coveoproductContext.coveoProduct;
    const coveoProductInfo = coveoproductContext.coveoProductInfo;

    const coveoPricing = coveoProductInfo?.pricing || coveoProduct.pricing;
    const isPendingVerification = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore.isPendingVerification,
    );
    const getCustomerCreditStatus = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore,
    );

    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [dealerModalIsOpen, setDealerModalIsOpen] = React.useState(false);
    const [inventoryResult, setInventoryResult] = React.useState<any>(null);
    const freeShippingAmount = Number(session.properties.freeshipThresholdAmt);
    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const [selectedProduct, setSelectedProduct] = React.useState<string>("");
    const componentRef = React.useRef<HTMLDivElement>(null);
    const addToListOpen = (id: string) => {
        setSelectedProduct(id);
        setIsOpen(prev => !prev);
    };

    const modalCloseHandler = () => {
        setModalIsOpen(false);
        setInventoryResult(null);
    };

    const viewAvailabilityByWarehouseClickHandler = () => {
        setModalIsOpen(true);

        customLoadInventory({
            productId: coveoProduct.productNumber,
            onSuccess(result: any) {
                setInventoryResult(result);
            },
        } as any);
    };

    const getCertified = () => {
        setDealerModalIsOpen(true);
    };

    const dealerModalCloseHandler = () => {
        setDealerModalIsOpen(false);
    };

    const carLineItem = cartState?.cartLines?.find(
        (cartLine: CartLineModel) => cartLine.erpNumber === coveoProduct!.productNumber,
    );
    const showAuthorizationRequired =
        coveoPricing &&
        coveoPricing.additionalResults &&
        coveoPricing.additionalResults.isVisible &&
        coveoPricing.additionalResults.isVisible === "N"
            ? "true"
            : "false";
    // const vendorAuthRequiredList = product?.properties?.vendorAuthRequiredList;

    const vendorAuthRequiredList = coveoProduct?.vendorAuthRequiredList?.toLowerCase();

    const brandName = coveoProduct.brandName ?? "";
    // const vendorAuthRequiredLink = product?.properties?.vendorAuthRequiredLink;

    const vendorAuthRequiredLink = coveoProduct?.vendorAuthRequiredLink;

    const clickHandler = () => {
        pushDealerAuthDataToDataLayer(brandName, vendorAuthRequiredLink, customerNumber, "Product List", session);
    };

    const MoreOptionAvailable = () => {
        return (
            <>
                <StyledWrapper
                    {...styles.variantContainer}
                    data-test-selector="moreOptionsAvailable"
                    style={{ minHeight: `${minVariantHeight}px` }}
                >
                    {coveoProduct.variantTypeId && <Typography>More Options Available</Typography>}
                </StyledWrapper>
            </>
        );
    };
    const [minPriceHeight, setMinPriceHeight] = useState(40);
    const [minStoreHeight, setMinStoreHeight] = useState(15);
    const [minDeliveryHeight, setMinDeliveryHeight] = useState(15);
    const [minStockHeight, setMinStockHeight] = useState(15);
    const [minVariantHeight, setMinVariantHeight] = useState(13);

    useEffect(() => {
        const maxPriceHeight = getMaxProductHeight('[data-test-selector="plpProductPrice"]');
        const maxStoreHeight = getMaxProductHeight('[data-test-selector="freeStorePickup"]');
        const maxDeliveryHeight = getMaxProductHeight('[data-test-selector="delivery"]');
        const maxStockAvailableHeight = getMaxProductHeight('[data-test-selector="stockAvailable"]');
        const maxVariantHeight = getMaxProductHeight('[data-test-selector="moreOptionsAvailable"]');

        setMinPriceHeight(maxPriceHeight);
        setMinStoreHeight(maxStoreHeight);
        setMinDeliveryHeight(maxDeliveryHeight);
        setMinStockHeight(maxStockAvailableHeight);
        setMinVariantHeight(maxVariantHeight);
    }, [!pricingLoading, coveoproductContext]);

    const isLbCoveoProduct = coveoProduct?.logicBroker?.toLowerCase() === "yes";
    const [accountPendingVerificatioPLP, setaccountPendingVerificatioPLP] = useState<string | null>("");

    {
        /* Based on credit status value from getcustomerstatus API N or O condition is added to show account pending verifaction message   */
    }
    useEffect(() => {
        setaccountPendingVerificatioPLP(getCustomerCreditStatus?.getcustomerStatus?.creditStatus);
    }, [accountPendingVerificatioPLP, getCustomerCreditStatus?.getcustomerStatus?.creditStatus]);

    {
        /* Based on credit status value from getcustomerstatus API N or O condition is added to show account pending verifaction message   */
    }

    return (
        <>
            {accountPendingVerificatioPLP !== "O" &&
            accountPendingVerificatioPLP !== "" &&
            accountPendingVerificatioPLP !== null ? (
                <StyledWrapper
                    {...styles.dealerCertificationWrapper}
                    className={view === "Grid" ? "productGridView" : "productListView"}
                >
                    <Typography {...styles.VerificationText} as="span">
                        {translate("Account Pending Verification")}
                    </Typography>
                </StyledWrapper>
            ) : (
                <>
                    {showAuthorizationRequired === "false" ? (
                        <StyledWrapper {...styles.wrapper}>
                            <StyledWrapper {...styles.contentWrapper}>
                                <StyledWrapper
                                    style={{ minHeight: `${minPriceHeight}px` }}
                                    data-test-selector="plpProductPrice"
                                >
                                    {showPrice && pricingLoading ? (
                                        <Typography
                                            {...styles.realTimeText}
                                            data-test-selector="productPrice_unitNetPrice"
                                        >
                                            {/* Below text might be required in future */}
                                            {/* {currencySymbol} */}
                                        </Typography>
                                    ) : (
                                        pricingIsAvailable && (
                                            <>
                                                {loadingRealtimePrice ? (
                                                    <LoadingSpinner />
                                                ) : (
                                                    <CoveoProductPrice
                                                        coveoProduct={coveoproductContext}
                                                        showLabel={false}
                                                        showSavings={true}
                                                        showSavingsAmount={productSettings.showSavingsAmount}
                                                        showSavingsPercent={productSettings.showSavingsPercent}
                                                        extendedStyles={styles.price}
                                                    />
                                                )}
                                                {/* <ProductQuantityBreakPricing extendedStyles={styles.quantityBreakPricing} /> */}
                                            </>
                                        )
                                    )}
                                </StyledWrapper>
                                {view === "List" && pricingIsAvailable && (
                                    <StyledWrapper {...styles.listAddToCartWrapper}>
                                        {carLineItem?.qtyOrdered && (
                                            <CoveoProductQuantityOrdered
                                                cartLine={carLineItem}
                                                extendedStyles={styles.quantityOrdered}
                                                variant="product listing list"
                                                cartStateLoading={cartStateLoading}
                                            />
                                        )}
                                        <CoveoProductAddToCartButton
                                            data-test-selector={`actionsAddToCart${coveoproductContext.coveoProduct.productId}`}
                                            extendedStyles={styles.addToCartButton}
                                            btnIsHidden={!!carLineItem?.qtyOrdered}
                                        />
                                    </StyledWrapper>
                                )}
                                {view === "List" && pricingError && (
                                    <StyledWrapper {...styles.priceAvailability} style={{ margin: "0 0 10px" }}>
                                        {!isPendingVerification && (
                                            <StyledWrapper>
                                                {/* Based on credit status value from getcustomerstatus API N or O condition is added to show account pending verifaction message   */}
                                                {accountPendingVerificatioPLP !== "O" &&
                                                accountPendingVerificatioPLP !== "" &&
                                                accountPendingVerificatioPLP !== null ? (
                                                    <Typography {...styles.VerificationText} as="span">
                                                        {translate("Account Pending Verification")}
                                                    </Typography>
                                                ) : (
                                                    <Typography>
                                                        {translate("Pricing Currently Not Available")}
                                                    </Typography>
                                                )}
                                            </StyledWrapper>
                                        )}
                                    </StyledWrapper>
                                )}
                                <StyledWrapper>
                                    {showAddToList && view === "List" && showADIAddToList ? (
                                        <StyledWrapper {...styles.addToListWrapper} ref={componentRef}>
                                            <Typography
                                                {...styles.addToListText}
                                                onClick={() => addToListOpen(coveoProduct.productNumber)}
                                            >
                                                {translate("Add To List")}
                                                <FilterDown />
                                            </Typography>

                                            {isOpen && selectedProduct === coveoProduct.productNumber ? (
                                                <CoveoAddToList
                                                    isOpen={isOpen}
                                                    coveoProduct={coveoproductContext}
                                                    setIsOpen={setIsOpen}
                                                    sourceName="Product List Page"
                                                />
                                            ) : null}
                                        </StyledWrapper>
                                    ) : null}
                                </StyledWrapper>
                                <Hidden below={view === "List" ? "lg" : "xs"}>
                                    <StyledWrapper {...styles.listDisplayWrapper}>
                                        <ADILBStorePickup isLbProduct={isLbCoveoProduct} />
                                        {!isPRRegion && (
                                            <StyledWrapper
                                                {...styles.listDisplay}
                                                data-test-selector="delivery"
                                                style={{ minHeight: `${minDeliveryHeight}px` }}
                                            >
                                                <DeliveryIcon />
                                                <StyledWrapper>
                                                    <Typography>{translate("Delivery")}</Typography>
                                                    {/* added a condition to not show below message if pricing not present for product */}
                                                    {Number(
                                                        coveoproductContext.coveoProductInfo.pricing?.unitNetPrice,
                                                    ) != 0 &&
                                                    coveoproductContext.coveoProductInfo.pricing?.unitNetPrice !=
                                                        null ? (
                                                        <Typography
                                                            {...(coveoproductContext.coveoProductInfo.pricing
                                                                ?.unitNetPrice &&
                                                            coveoproductContext.coveoProductInfo.pricing
                                                                ?.unitNetPrice >= freeShippingAmount
                                                                ? styles.free
                                                                : styles.notFree)}
                                                        >
                                                            {coveoproductContext.coveoProductInfo.pricing
                                                                ?.unitNetPrice &&
                                                            coveoproductContext.coveoProductInfo.pricing
                                                                ?.unitNetPrice >= freeShippingAmount
                                                                ? translate("Free")
                                                                : translate(
                                                                      `Free for orders $${freeShippingAmount} & above`,
                                                                  )}
                                                        </Typography>
                                                    ) : (
                                                        <Typography></Typography>
                                                    )}
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        )}
                                    </StyledWrapper>
                                </Hidden>
                                {view === "List" && (
                                    <>
                                        <StyledWrapper {...styles.listVariantWrap}>
                                            <MoreOptionAvailable />
                                        </StyledWrapper>
                                    </>
                                )}
                                <StyledWrapper
                                    data-test-selector="stockAvailable"
                                    style={{ minHeight: `${minStockHeight}px` }}
                                >
                                    {view === "Grid" &&
                                        !pricingLoading &&
                                        (!pricingError ? (
                                            isLbCoveoProduct ? (
                                                <ADILBShippedByVendor vendorName={brandName} view="Grid" />
                                            ) : (
                                                <>
                                                    <StyledWrapper {...styles.availability}>
                                                        {!coveoProduct.availability
                                                            ?.toString()
                                                            ?.includes("Special Order") ? (
                                                            <Link onClick={viewAvailabilityByWarehouseClickHandler}>
                                                                {translate("Stock Availability")}
                                                            </Link>
                                                        ) : (
                                                            translate("Special Order")
                                                        )}
                                                    </StyledWrapper>
                                                    <Modal
                                                        {...styles.availabilityByWarehouseModal}
                                                        headline={translate("Stock Availability")}
                                                        isOpen={modalIsOpen}
                                                        handleClose={modalCloseHandler}
                                                    >
                                                        <ADILocationFinder
                                                            productId={coveoProduct.productNumber}
                                                            warehouseDetails={inventoryResult}
                                                        />
                                                    </Modal>
                                                </>
                                            )
                                        ) : (
                                            <StyledWrapper
                                                {...styles.priceAvailability}
                                                style={{ margin: "-10px 0 10px 0" }}
                                            >
                                                <StyledWrapper>
                                                    {!isPendingVerification &&
                                                        (accountPendingVerificatioPLP !== "O" &&
                                                        accountPendingVerificatioPLP !== "" &&
                                                        accountPendingVerificatioPLP !== null ? (
                                                            <Typography {...styles.VerificationText} as="span">
                                                                {translate("Account Pending Verification")}
                                                            </Typography>
                                                        ) : (
                                                            <Typography>
                                                                {translate("Pricing Currently Not Available")}
                                                            </Typography>
                                                        ))}
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        ))}
                                </StyledWrapper>
                            </StyledWrapper>

                            {view === "Grid" && pricingIsAvailable && (
                                <>
                                    <StyledWrapper {...styles.addToCartWrapper}>
                                        <StyledWrapper {...styles.gridVariantWrap}>
                                            <MoreOptionAvailable />
                                        </StyledWrapper>
                                        {carLineItem?.qtyOrdered && (
                                            <CoveoProductQuantityOrdered
                                                cartLine={carLineItem}
                                                extendedStyles={styles.quantityOrdered}
                                                variant="product listing grid"
                                                cartStateLoading={cartStateLoading}
                                            />
                                        )}
                                        <CoveoProductAddToCartButton
                                            data-test-selector={`actionsAddToCart${coveoproductContext.coveoProduct.productId}`}
                                            extendedStyles={styles.addToCartButton}
                                            btnIsHidden={!!carLineItem?.qtyOrdered}
                                        />
                                    </StyledWrapper>
                                </>
                            )}
                        </StyledWrapper>
                    ) : vendorAuthRequiredList === "false" && !isPendingVerification ? (
                        <StyledWrapper
                            {...styles.dealerCertificationWrapper}
                            className={view === "Grid" ? "productGridView" : "productListView"}
                        >
                            {accountPendingVerificatioPLP !== "O" &&
                            accountPendingVerificatioPLP !== "" &&
                            accountPendingVerificatioPLP !== null ? (
                                <Typography {...styles.VerificationText} as="span">
                                    {translate("Account Pending Verification")}
                                </Typography>
                            ) : (
                                <StyledWrapper>
                                    <StyledWrapper {...styles.dealerCertificationTitle}>
                                        Dealer Certification Required
                                    </StyledWrapper>
                                    <Link {...styles.getCertifiedText} onClick={getCertified}>
                                        Get Certified
                                    </Link>
                                </StyledWrapper>
                            )}
                        </StyledWrapper>
                    ) : (
                        vendorAuthRequiredList === "true" &&
                        !isPendingVerification && (
                            <StyledWrapper
                                {...styles.dealerCertificationWrapper}
                                className={view === "Grid" ? "productGridView" : "productListView"}
                            >
                                <StyledWrapper {...styles.dealerCertificationTitle}>
                                    Dealer Certification Required
                                </StyledWrapper>
                                <Link {...styles.getCertifiedText} onClick={getCertified}>
                                    Get Certified
                                </Link>
                                {view === "List" && (
                                    <>
                                        <StyledWrapper {...styles.listVariantWrap}>
                                            <MoreOptionAvailable />
                                        </StyledWrapper>
                                    </>
                                )}
                            </StyledWrapper>
                        )
                    )}
                    <CoveoDealerCertModal
                        open={dealerModalIsOpen}
                        coveoProduct={coveoProduct}
                        onClose={dealerModalCloseHandler}
                    />
                </>
            )}
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withProductContext(CoveoProductListActions));
